export const DEFAULT_DELAY_MS = 300;
export const CUSTOM_DATE_TIME_FORMAT = {
  parse: {
    dateInput: 'dd-MM-yyyy',
    timeInput: 'HH:mm',
  },
  display: {
    dateInput: 'dd-MMM-yyyy',
    timeInput: 'HH:mm',
    monthYearLabel: 'MMM yyyy',
    dateA11yLabel: 'dd MMM yyyy',
    monthYearA11yLabel: 'MMMM yyyy',
    timeOptionLabel: 'HH:mm',
  },
};
